import { useEffect } from 'react';

const GA_MEASUREMENT_ID = 'G-296WTKQ9TF';

function loadGA4() {
  if (document.getElementById('ga4-script')) return;

  const script = document.createElement('script');
  script.id = 'ga4-script';
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID, { anonymize_ip: true });
}

function hasAnalyticsConsent() {
  try {
    const consent = JSON.parse(localStorage.getItem('cookie_consent') || '{}');
    return consent.accepted === true && consent.preferences?.analytics === true;
  } catch {
    return false;
  }
}

export default function GoogleAnalytics() {
  useEffect(() => {
    if (hasAnalyticsConsent()) {
      loadGA4();
    }

    // Listen for consent changes (fired from CookieConsent component)
    const handleConsent = () => {
      if (hasAnalyticsConsent()) loadGA4();
    };
    window.addEventListener('cookie_consent_updated', handleConsent);
    return () => window.removeEventListener('cookie_consent_updated', handleConsent);
  }, []);

  return null;
}
